module.exports = __webpack_public_path__ + "img/arachides.1809a90a.svg";